export default __webpack_public_path__ + "static/media/whiteFlag.f62af4bc.svg";